import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { updateEntry } from "../../../../../../../actions/entry";
import { TeamSelector } from "../../../../../../layout/eventDivision/TeamSelector";

export const AddToTeamAndConfirmButton = ({ athlete, tagId, setDisappearingEvent, entries }) => {
    const dispatch = useDispatch();
    const addToTeam = useCallback(teamId => {
        const entry = entries.find(e => "" + e.id === teamId);
        const maxOrder = Math.max(-1, ...entry.teamMembers.map(m => m.order));
        return dispatch(updateEntry(entry.eventDivisionId, entry.id, {
            status: "confirmed",
            team_members_attributes: [{
                athlete_id: athlete.id,
                nfc_tag_id: tagId,
                order: maxOrder + 1
            }]
        })).then(() => setDisappearingEvent({ type: "success" }));
    }, [athlete, tagId, entries]);

    return <TeamSelector onSubmit={addToTeam} teams={entries}/>;
};
